import { of } from 'rxjs';

import { switchMap, map, withLatestFrom, catchError, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { CAAction, CustomerTeam } from '../actions';
import * as selectors from '../reducers/index';
import { MemberCustomers } from './member-customers.actions';
import { auth } from '../auth/auth.selectors';
import { MembersService } from '@careapp-group/ng-sdk';

@Injectable()
export class MemberCustomersEffects {
  getAssignedCustomers = createEffect(() =>
    this.actions$.pipe(
      ofType(MemberCustomers.REQUEST_ALL_PAGINATED),
      withLatestFrom(
        this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
        this.store.select(selectors.getSelectedId(selectors.TENANTS))
      ),
      filter(([action, organisationId, tenantId]) => !!organisationId || !!tenantId),
      switchMap(([action, organisationId, tenantId]) => {
        return this.membersService
          .listMemberCustomers({ id: (<any>action).paginator, organisationId, tenantId })
          .pipe(
            map((payload: any) => {
              return MemberCustomers.ResponseSuccessAllPaginatedAction({
                filter: {},
                paginator: (<any>action).paginator,
                items: payload,
              });
            }),
            catchError((err) =>
              of(MemberCustomers.ResponseFailAllPaginatedAction(err, (<any>action).paginator))
            )
          );
      })
    )
  );

  reflectCustomerTeamRemovals = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.ResponseSuccessRemove),
      withLatestFrom(this.store.pipe(select(auth.getLoggedInUser))),
      switchMap(([action, auth]) => {
        if (auth.id === action.memberId) {
          return [
            MemberCustomers.RequestRemoveMemberFromCustomer({
              memberId: auth.id,
              customerId: action.customerId,
            }),
          ];
        }
        return [];
      })
    )
  );

  reflectCustomerTeamAdditions = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.RESPONSE_SUCCESS_CREATE),
      withLatestFrom(this.store.pipe(select(auth.getLoggedInUser))),
      switchMap(([action, auth]) => {
        return [MemberCustomers.RequestAllPaginatedAction({}, auth.id)];
      })
    )
  );

  reflectAddingMemberToCustomer = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerTeam.ResponseSuccessAddMemberToCustomer),
      withLatestFrom(this.store.pipe(select(auth.getLoggedInUser))),
      switchMap(([action, auth]) => {
        return [MemberCustomers.RequestAllPaginatedAction({}, auth.id)];
      })
    )
  );

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private membersService: MembersService
  ) {}
}
